import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import { usePopupState, bindTrigger, bindMenu } from "material-ui-popup-state/hooks";
import { Trad } from "../../components/";
import bg from "../images/quick_actions_bg.jpg";

const useStyles = makeStyles(theme => ({
    menuCard: {
        width: 260
    },
    menuCardTitle: {
        height: 60,
        textAlign: "center",
        color: theme.palette.common.white
    },
    icon: {
        width: 40,
        height: 40
    }
}));

export const _AdminMenu = () => {
    const classes = useStyles();
    const popupState = usePopupState({ variant: "popover", popupId: "userMenu" });

    return (
        <>
            <IconButton edge="start" color="inherit" aria-label="settings" {...bindTrigger(popupState)}>
                <SettingsIcon />
            </IconButton>
            <Popover
                {...bindMenu(popupState)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                TransitionComponent={Collapse}
            >
                <Card className={classes.menuCard}>
                    <CardMedia className={classes.menuCardTitle} component="div" image={bg}>
                        <CardHeader title={Trad.Trad("Menu amministrativo")} titleTypographyProps={{ variant: "h6", component: "h6" }} />
                    </CardMedia>
                    <CardActionArea href="/Utente" onClick={popupState.close}>
                        <CardContent>
                            <Box color="text.secondary" justifyContent="center" textAlign="center">
                                <PersonIcon className={classes.icon} />
                                <p>{Trad.Trad("Gestione utenti")}</p>
                            </Box>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </Popover>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/AdminMenu.tsx